import { datadogLogs } from '@datadog/browser-logs';
import HTTP from '../../core/http';

export function getJobDetails(id, cancelToken) {
  return new Promise((resolve, reject) => {
    HTTP.get('jobs/central', {
      params: {
        id,
      },
      cancelToken,
    })
      .then(({ data }) => {
        try {
          if (data.results.length === 1 && data.results[0]) {
            resolve(data.results[0]);
          } else {
            reject(new Error('No matching results'));
          }
        } catch (err) {
          reject(err);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function updateSchedule(jobId, updatedDatetime, ignoreWarnings = false) {
  return new Promise((resolve, reject) => {
    HTTP.put(`/jobs/${jobId}/update-schedule/`, {
      job_start_after: updatedDatetime,
      ignore_warnings: ignoreWarnings,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getJobDeclineReason(jobId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/job_offers/job/${jobId}/last-declined/`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          datadogLogs.logger.error(
            `Received 404 on getting Decline Reason for jobId: ${jobId}`
          );
        }
        reject(error);
      });
  });
}
